var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-user';
                    var viewUrl = 'sprite.svg#view-icon-user';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-user#icon-user';
                            viewUrl = 'sprite.svg?icon-user#view-icon-user';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 20',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };